// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.getintouch_modal {
  padding: 30px 30px 40px 30px;
  border-radius: 8px;
}

.getintouch_form {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.getintouch_heading {
  color: #fff;
  font-family: "Inter";
  font-size: clamp(30px, 3vw, 42px) !important;
  font-style: normal;
  font-weight: 700;
  margin-bottom: 30px;
}

.getintouch_field_box {
  width: 100%;
  display: flex;
  flex-direction: column;
}

.getintouch_field_box > label {
  color: #fff;
  font-family: "Open Sans";
  font-size: 14px;
  font-weight: 400;
  margin-top: 30px;
  margin-bottom: 10px;
}

.getintouch_field {
  width: 385px;
  height: 48px !important;
  flex-shrink: 0;
  padding: 0 17px;
  border-radius: 4px;
  background-color: transparent;
  border: 1px solid #606675;
  color: #fff;
  font-family: "Open Sans";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px;
  letter-spacing: 0.25px;
  outline: none;
}

.getintouch_field::placeholder {
  color: #fff;
  font-family: "Roboto";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px;
  letter-spacing: 0.25px;
  opacity: 0.4;
}

.getintouch_text_area_field {
  width: 385px;
  height: 150px !important;
  flex-shrink: 0;
  padding: 12px 17px;
  background-color: transparent;
  border-radius: 4px;
  border: 1px solid #606675;

  color: #fff;
  font-family: "Open Sans";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.25px;
  outline: none;
}

.getintouch_invalid_feedback {
  color: #e42323;
  font-family: "Roboto";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px;
  letter-spacing: 0.25px;
  margin-top: 4px;
}

.getintouch_join_btn_div {
  margin-top: 30px !important;
  width: -moz-fit-content !important;
  width: fit-content !important;
  border: 1.4px solid #fff !important;
  color: #fff;
  text-align: center;
  font-family: "Open Sans";
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 136.304%;
  padding: 10px 20px !important;
}
@media screen and (max-width: 600px) {
  .getintouch_field {
    width: 280px;
  }
  .getintouch_text_area_field {
    width: 280px;
  }
  .getintouch_join_btn_div {
    font-size: 16px;
  }
  .getintouch_field_box > label {
    margin-top: 10px;
    margin-bottom: 10px;
  }
  .getintouch_modal {
    padding: 20px 20px 30px 20px;
  }

  .getintouch_heading {
    margin-bottom: 20px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/common/getInTouch/getInTouch.css"],"names":[],"mappings":"AAAA;EACE,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,4CAA4C;EAC5C,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,6BAA6B;EAC7B,yBAAyB;EACzB,WAAW;EACX,wBAAwB;EACxB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,wBAAwB;EACxB,cAAc;EACd,kBAAkB;EAClB,6BAA6B;EAC7B,kBAAkB;EAClB,yBAAyB;;EAEzB,WAAW;EACX,wBAAwB;EACxB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,kCAA6B;EAA7B,6BAA6B;EAC7B,mCAAmC;EACnC,WAAW;EACX,kBAAkB;EAClB,wBAAwB;EACxB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,6BAA6B;AAC/B;AACA;EACE;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,4BAA4B;EAC9B;;EAEA;IACE,mBAAmB;EACrB;AACF","sourcesContent":[".getintouch_modal {\n  padding: 30px 30px 40px 30px;\n  border-radius: 8px;\n}\n\n.getintouch_form {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n}\n\n.getintouch_heading {\n  color: #fff;\n  font-family: \"Inter\";\n  font-size: clamp(30px, 3vw, 42px) !important;\n  font-style: normal;\n  font-weight: 700;\n  margin-bottom: 30px;\n}\n\n.getintouch_field_box {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n.getintouch_field_box > label {\n  color: #fff;\n  font-family: \"Open Sans\";\n  font-size: 14px;\n  font-weight: 400;\n  margin-top: 30px;\n  margin-bottom: 10px;\n}\n\n.getintouch_field {\n  width: 385px;\n  height: 48px !important;\n  flex-shrink: 0;\n  padding: 0 17px;\n  border-radius: 4px;\n  background-color: transparent;\n  border: 1px solid #606675;\n  color: #fff;\n  font-family: \"Open Sans\";\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 28px;\n  letter-spacing: 0.25px;\n  outline: none;\n}\n\n.getintouch_field::placeholder {\n  color: #fff;\n  font-family: \"Roboto\";\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 28px;\n  letter-spacing: 0.25px;\n  opacity: 0.4;\n}\n\n.getintouch_text_area_field {\n  width: 385px;\n  height: 150px !important;\n  flex-shrink: 0;\n  padding: 12px 17px;\n  background-color: transparent;\n  border-radius: 4px;\n  border: 1px solid #606675;\n\n  color: #fff;\n  font-family: \"Open Sans\";\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px;\n  letter-spacing: 0.25px;\n  outline: none;\n}\n\n.getintouch_invalid_feedback {\n  color: #e42323;\n  font-family: \"Roboto\";\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 28px;\n  letter-spacing: 0.25px;\n  margin-top: 4px;\n}\n\n.getintouch_join_btn_div {\n  margin-top: 30px !important;\n  width: fit-content !important;\n  border: 1.4px solid #fff !important;\n  color: #fff;\n  text-align: center;\n  font-family: \"Open Sans\";\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 136.304%;\n  padding: 10px 20px !important;\n}\n@media screen and (max-width: 600px) {\n  .getintouch_field {\n    width: 280px;\n  }\n  .getintouch_text_area_field {\n    width: 280px;\n  }\n  .getintouch_join_btn_div {\n    font-size: 16px;\n  }\n  .getintouch_field_box > label {\n    margin-top: 10px;\n    margin-bottom: 10px;\n  }\n  .getintouch_modal {\n    padding: 20px 20px 30px 20px;\n  }\n\n  .getintouch_heading {\n    margin-bottom: 20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
